<template>
  <div>
    <Locale></Locale>
    <div class="menu-area">
      <img :src="menu.imageUrl" />
      <h1 class="text-h3 mt-12">
        {{ $store.state.localeEn ? menu.menutitle_en : menu.menutitle }}
      </h1>
      <p class="text-body1 mt-6">
        {{ $store.state.localeEn ? menu.menucontents_en : menu.menucontents }}
      </p>
    </div>
  </div>
</template>

<script>
import Locale from "@/components/Locale";
export default {
  name: "Menu",
  components: {
    Locale,
  },
  data() {
    return {
      menu: this.$store.state.menus.find(
        (el) => el.menutitle === this.$route.params.id
      ),
    };
  },
};
</script>

<style>
.menu-area {
  width: 90%;
  max-width: 680px;
  margin: 100px auto;
  text-align: center;
}

.menu-area img {
  width: 100%;
  max-width: 500px;
}
</style>
